// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2T6G8","footer":"ModalInfo_footer__1Oczj"};